import { authService } from '@/api';
import { welcome } from '../../utils/utils';
import { getToken, removeToken } from 'minerva-ui-sdk';
import jwt from 'jsonwebtoken';

const user = {
  state: {
    name: '',
    welcome: '',
    roles: null,
    info: {
      accountDisplayName: '',
      tenantId: null
    }
  },

  mutations: {
    setUser: (state, { name, welcome }) => {
      state.name = name;
      state.welcome = welcome;
    },
    setRoles: (state, roles) => {
      state.roles = roles;
    },
    setInfo: (state, info) => {
      state.info = info;
    }
  },

  actions: {
    async GetInfo({ commit }) {
      const res = await authService.getInfo();
      const userInfo = res.data;

      if (userInfo.roles) {
        const userInformation = Object.assign({}, userInfo);
        const { tenantId } = jwt.decode(getToken());
        userInformation.tenantId = tenantId;
        commit('setRoles', userInfo.roles);
        commit('setUser', { name: userInfo.accountDisplayName, welcome: welcome() });
        commit('setInfo', userInformation);
        return userInfo;
      } else {
        throw new Error('getInfo: roles must be a non-null array !');
      }
    },

    Logout({ commit }) {
      return new Promise((resolve) => {
        commit('setRoles', {});
        removeToken();
        resolve()
      })
    }
  }
};

export default user
